<template>
	<a-popover :placement="placement">
		<template slot="title">
			<fa-icon
				:icon="['fa','question-circle']"
				class="mr-2"
			/> {{ title }}
		</template>
		<template slot="content">
			<div
				class="font-size-12 text-justify"
				:style="{'max-width': width+'px'}"
			>
				<slot />
			</div>
		</template>

		<fa-icon
			:icon="['fa','question-circle']"
		/>
	</a-popover>
</template>
<script>
export default {
	name: 'GHelp',
	props: {
		title: {
			type: String,
			default: ''
		},
		width: {
			type: Number,
			default: 200
		},
		placement: {
			type: String,
			default: 'bottomLeft'
		}
	}
};
</script>
